<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading">
    <div class="banner">
      <button type="button" class="back-button" (click)="reroute()">
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span class="back-text">Tillbaka</span>
      </button>
    </div>

    <div class="contents-wrapper">
      <div *ngIf="existingLeq" class="contents-container">
        <div class="leq-summary">
          <ng-container>
            <h4 class="header">Dina lämnade uppgifter</h4>
            <p class="sub-header">Klicka på fortsätt om inget har ändrats.</p>
          </ng-container>

          <ng-container
            *ngIf="
              selectedMethodLeqType === LeqType.STANDARD &&
              existingLeq.employment
            "
          >
            <hr class="details-divider" />
            <div class="details-container">
              <div class="details-key">Sysselsättning</div>
              <div class="details-value pr-details">
                {{ occupationStatusLabel }}
              </div>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              selectedMethodLeqType === LeqType.STANDARD &&
              existingLeq.income !== null
            "
          >
            <hr class="details-divider" />
            <div class="details-container">
              <div class="details-key">Månadsinkomst efter skatt</div>
              <div class="details-value pr-details">
                {{ existingLeq.income | currency: 'kr ':'code':'1.0-0':'sv' }}
              </div>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              selectedMethodLeqType === LeqType.STANDARD &&
              existingLeq.housingCosts !== null
            "
          >
            <hr class="details-divider" />
            <div class="details-container">
              <div class="details-key">Boendekostnad per månad</div>
              <div
                *ngIf="existingLeq.housingCosts > 0"
                class="details-value pr-details"
              >
                {{
                  existingLeq.housingCosts | currency: 'kr ':'code':'1.0-0':'sv'
                }}
              </div>
              <div
                *ngIf="existingLeq.housingCosts === 0"
                class="details-value pr-details"
              >
                Nej
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="existingLeq.creditCosts !== null">
            <hr class="details-divider" />
            <div class="details-container">
              <div class="details-key">Privatlån (blancolån)</div>
              <div
                *ngIf="existingLeq.creditCosts > 0"
                class="details-value pr-details"
              >
                {{
                  existingLeq.creditCosts | currency: 'kr ':'code':'1.0-0':'sv'
                }}
              </div>
              <div
                *ngIf="existingLeq.creditCosts === 0"
                class="details-value pr-details"
              >
                Nej
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="existingLeq.studentLoan !== null">
            <hr class="details-divider" />
            <div class="details-container">
              <div class="details-key">CSN-lån</div>
              <div
                *ngIf="existingLeq.studentLoan > 0"
                class="details-value pr-details"
              >
                {{
                  existingLeq.studentLoan | currency: 'kr ':'code':'1.0-0':'sv'
                }}
                / mån
              </div>
              <div
                *ngIf="existingLeq.studentLoan === 0"
                class="details-value pr-details"
              >
                Nej
              </div>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              selectedMethodLeqType === LeqType.STANDARD &&
              existingLeq.miscExpenses !== null
            "
          >
            <hr class="details-divider" />
            <div class="details-container">
              <div class="details-key">Övriga levnadskostnader</div>
              <div class="details-value pr-details">
                {{
                  existingLeq.miscExpenses | currency: 'kr ':'code':'1.0-0':'sv'
                }}
                / mån
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="existingLeq.numberOfChildren !== null">
            <hr class="details-divider" />
            <div class="details-container">
              <div class="details-key">Antal barn i hushållet</div>
              <div class="details-value pr-details">
                {{ getNumberOfChildren() }}
              </div>
            </div>
          </ng-container>

          <hr class="details-divider" />
        </div>

        <div class="footer-container">
          <zaver-basic-button
            class="update-button"
            text="Ändra svar"
            [secondary]="true"
            [md]="true"
            [disabled]="navigationInProgress"
            (click)="navigateToLeqForm()"
          >
          </zaver-basic-button>

          <zaver-basic-button
            text="Fortsätt"
            [primary]="true"
            [md]="true"
            [disabled]="navigationInProgress"
            (click)="continueToNextStepInJourney()"
          >
          </zaver-basic-button>
        </div>
      </div>
    </div>
  </div>
</div>
